// src/pages/Quote.js
import React, { useState } from "react";
import axios from "axios";
import "./Quote.css"; // Import updated CSS

function Quote() {
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    incidentType: "",
    incidentDate: "",
    incidentLocation: "",
    injuries: "",
    insuranceInfo: "",
    notes: "",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await axios.post("php/quote.php", formData, {
        headers: { "Content-Type": "application/json" },
      });

      setMessage(response.data.message);
    } catch (error) {
      setMessage("We couldn't send your request. Please try again.");
    }
  };

  return (
    <div className="quote-container">
      {/* Title */}
      <h1 className="quote-title">Request a Free Consultation</h1>

      <form onSubmit={handleSubmit} className="quote-form">
        <label>Full Name</label>
        <input
          type="text"
          name="fullName"
          value={formData.fullName}
          onChange={handleChange}
          required
          placeholder="Your first and last name"
        />

        <label>Phone Number</label>
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
          placeholder="(951) 555-1234"
        />

        <label>Email (optional)</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="For updates and confirmations"
        />

        <label>Type of Incident</label>
        <select
          name="incidentType"
          value={formData.incidentType}
          onChange={handleChange}
          required
        >
          <option value="">-- Select an option --</option>
          <option value="Car Accident">Car Accident</option>
          <option value="Motorcycle Accident">Motorcycle Accident</option>
          <option value="Slip & Fall">Slip & Fall</option>
          <option value="Rideshare (Uber/Lyft)">Rideshare (Uber/Lyft)</option>
          <option value="Other">Other</option>
        </select>

        <label>Date of Incident (approximate)</label>
        <input
          type="date"
          name="incidentDate"
          value={formData.incidentDate}
          onChange={handleChange}
          required
        />

        <label>Location of Incident (City / Intersection)</label>
        <input
          type="text"
          name="incidentLocation"
          value={formData.incidentLocation}
          onChange={handleChange}
          required
          placeholder="Example: Redlands, CA (near 5th & State St.)"
        />

        <label>Injuries & Medical Care (brief)</label>
        <textarea
          name="injuries"
          value={formData.injuries}
          onChange={handleChange}
          required
          placeholder="Example: Back pain, ER visit, ongoing treatment…"
        ></textarea>

        <label>Insurance Information (optional)</label>
        <textarea
          name="insuranceInfo"
          value={formData.insuranceInfo}
          onChange={handleChange}
          placeholder="Example: Your auto insurance / other party insurance (if known)"
        ></textarea>

        <label>Additional Details (optional)</label>
        <textarea
          name="notes"
          value={formData.notes}
          onChange={handleChange}
          placeholder="Anything else that may help us understand your situation."
        ></textarea>

        <p className="quote-disclaimer">
          Submitting this form does not create an attorney-client relationship.
        </p>

        <button type="submit" className="submit-btn">
          Request Free Consultation
        </button>
      </form>

      {message && <p className="message">{message}</p>}
    </div>
  );
}

export default Quote;